"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    CLIENT_RENDERED_ROUTE_MATCHERS: [
        'marketplace',
        'brand',
    ],
    REGION_FILTER_CODES: [
        'au',
        'be',
        'ca',
        'ch',
        'de',
        'dk',
        'es',
        'fi',
        'fr',
        'hk',
        'ie',
        'it',
        'jp',
        'lu',
        'mx',
        'nl',
        'no',
        'nz',
        'pt',
        'ru',
        'se',
        'uk',
    ],
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/constants.js
// module id = Rz4Z
// module chunks = 20 21 22